// Specific to the inventory module.
define('lib/transforms/inventory.tmpl.module',[
  'lib/3dImagesRandomColor',
  'lib/util/sanity/toSeriesDescription',
  'lib/readable-monetize'
], function (
  randomColor,
  toSeriesDescription,
  readableMonetize
) {
  // move the firstTrim to the front of the array
  function __orderTrims(arr, firstTrim) {
    // find the index in arr whose __grade.code === firstTrim
    var matchingTrimIdx = arr.findIndex(function(arrItem) {
      return arrItem.__grade.code === firstTrim;
    });
    var removed = arr.splice(matchingTrimIdx, 1);
    arr.unshift(removed[0]); // put the removed item as the first
    return arr;
  }

  // options = {grade: arr, model: arr, series: arr, images: obj [, firstTrim: string]}
  return function transformInvMod(options) {
    var grade = options.grade;
    var model = options.model;
    var series = options.series;
    var images = options.images;
    var firstTrim = options.firstTrim ? options.firstTrim : null;

    var gradeXformed = [];
    // all we need from the grade array are title and count
    for (var i = 0; i < grade.length; i++) {
      // build proper image path
      var tmpObj = {
        __grade: grade[i],
        count: readableMonetize(grade[i].count),
        grade: grade[i].title.replace(series[0].title, '') // if series title appears in this grade title, remove it
      };
      var seriesDescription = toSeriesDescription(series[0].title, grade[i].title);
      var matchingModel = model.find(function (modelItem) {
        var description = modelItem.description.replace('&#8209;', '-').replace('‑', '-'); // should create a lookup table to replace these
        return description.toUpperCase() === seriesDescription.toUpperCase();
      });

      tmpObj.__model = matchingModel;
      tmpObj.modelCode = Number(matchingModel.code);

      // tack on a character count that includes description (Series & trim). + 5 (year and a space)
      // move this to "inline" transform in module.inv.specific.
      tmpObj.seriesYearModelCharCount = Number(tmpObj.__model.description.length + 5);

      // Only add this modelCode, if if we have a 3dimage for it
      if (images.hasOwnProperty(tmpObj.modelCode)) {
        tmpObj.image = randomColor(images[tmpObj.modelCode].exteriorcolor, '680_383_PNG', 1);
        tmpObj.__images = images[tmpObj.modelCode];
        gradeXformed.push(tmpObj);
      }
    }

    if (firstTrim) {
      __orderTrims(gradeXformed, firstTrim);
    }


    // reorder gradeXformed array if a startTrim was chosen

    return {
      series: series[0].title,
      records: gradeXformed
    };
  };
});

